// eslint-disable-next-line import/no-internal-modules
import Highcharts from 'highcharts/highstock';
import { debounce } from 'lodash';

const getDirection = debounce((delta) => {
  return delta < 0 ? 1 : -1;
}, 10);

const setExtremesForChart = async (event: React.MouseEvent, chart) => {
  const axis = chart.xAxis[0];
  const e = chart.pointer.normalize(event);
  const delta = e.detail || e.wheelDelta / 120;
  const direction = getDirection(delta);

  if (
    chart.isInsidePlot(e.chartX - chart.plotLeft, e.chartY - chart.plotTop) &&
    direction
  ) {
    const extr = axis.getExtremes();
    const step = ((extr.max - extr.min) / 75) * direction;

    axis.setExtremes(extr.min + step, extr.max + step, true, false);
  }
};

export const scrollIntialiser = (H: typeof Highcharts) => {
  H.wrap(H.Chart.prototype, 'render', function (this: any, proceed) {
    proceed.call(this);
    H.addEvent(this.container, 'mousewheel', (event: React.MouseEvent) => {
      setExtremesForChart(event, this);
      event?.stopPropagation();
      event?.preventDefault();
    });
  });
};

export const chartCleanup = (H: typeof Highcharts) => {
  H.wrap(H.Chart.prototype, 'render', function (this: any, proceed) {
    proceed.call(this);
    H.removeEvent(this.container, 'mousewheel');
  });
};
